var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__head-contents"},[_c('CPageTitle',{staticClass:"report-filters-title",attrs:{"title":_vm.$t('Report Filters')}}),_c('DropdownMenu',{attrs:{"items":_vm.menuItems,"autoClose":""},on:{"click":_vm.onClickActionMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }